import React from 'react';
import classNames from 'classnames';
import FJToolTip from '../FJToolTip/FJToolTip';
import Styles from './FJSwitchButton.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJUtil from '../../../util/FJUtil';

const FJSwitchButton = props => {
    let { active, style, className, tooltip, tooltipPlacement = 'bottom', onChange, type = 'gradient' } = props;

    const _onClick = () => {
        onChange && onChange(!active);
    };

    const containerClass = classNames(Styles.container, Styles[type], className, { [Styles.active]: active });
    // 移动端不展示tooltip
    const tooltipText = tooltip
        ? tooltip
        : FJUtil.isMobile()
          ? ''
          : active
            ? FJLocalStore._('turn-off')
            : FJLocalStore._('turn-on');

    return (
        <FJToolTip title={tooltipText} placement={tooltipPlacement}>
            <div className={containerClass} style={style} onClick={_onClick}>
                <div className={Styles.switch_handle} />
            </div>
        </FJToolTip>
    );
};

export default FJSwitchButton;
